<template>
  <div class="company-detail">
    <div class="tab-container">
      <mobile-tab-fold :tabs="visibleTabs" :value="activeName" @input="onFoldTab" />
      <el-tabs v-model="activeName" @tab-click="tabsChange">
        <el-tab-pane :label="item.label" :name="item.name" v-for="(item, k) in visibleTabs" :key="k">
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import MobileTabFold from '@/components/MobileTabFold/index.vue'

export default {
  components: { MobileTabFold },
  data() {
    return {
      activeName: 'companyProfile',
      tabList: [
        {
          name: 'companyProfile',
          label: '公司介绍',
         
        },
        {
          name: 'enterpriseQualification',
          label: '企业资质',
        },
        {
          name: 'contactus',
          label: '联系我们',
        },
      
      ],
      isMobile: false
    }
  },
  computed: {
    visibleTabs() {
      if (!this.isMobile) return this.tabList
      return this.tabList.filter(item => item.name !== 'enterpriseQualification')
    }
  },
  watch: {
  },
  mounted() {
    this.syncMobile()
    window.addEventListener('resize', this.syncMobile)
    const anchorPoint = this.$route.query.anchorPoint
    if (anchorPoint) {
      this.activeName = anchorPoint
      this.tabsChange()
    } 
  },
  destroyed() {
    window.removeEventListener('resize', this.syncMobile)
  },
  methods: {
    syncMobile() {
      this.isMobile = window.innerWidth < 768
      if (this.isMobile && this.activeName === 'enterpriseQualification') {
        this.activeName = 'companyProfile'
      }
    },
    tabsChange(val) {
      this.$emit('tabsChange', this.activeName)
    },
    onFoldTab(name) {
      this.activeName = name
      this.$emit('tabsChange', name)
    }
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.company-detail {
  width: 100%;
  background-color: #f0f2f5;
  padding: 2.5rem 26rem 0rem;
  .tab-container {
    width: 100%;
    ::v-deep .el-tabs {
      width: 100%;
      .el-tabs__nav-wrap::after {
        display: none;
      }
      .el-tabs__header {
        margin: 0;
        .el-tabs__nav {
          width: 100%;

          .el-tabs__item {
            width: 28rem;
            height: 4.6rem;
            display: inline-flex;
            justify-content: center;
            font-size: 2rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            line-height: 2rem;
            box-shadow: none;
          }

          .el-tabs__active-bar {
            height: 0.2rem;
            width: 33%;
            background-color: #FB0000;
          }

          .el-tabs__item.is-active, .el-tabs__item:hover {
            color: #FB0000;
          }
        }
      }
      .el-tabs__content {
        width: 100%;
        background-size: 100% 100%;
      }
    }

  }
}

@import "@/styles/mixins.scss";

@include mobile {
  .company-detail {
    padding: 6.4rem 1.6rem 0;
    ::v-deep .el-tabs__header {
      display: none !important;
    }
  }
}
</style>
